import { Routes } from '@angular/router';
import { MsalGuard } from '@groundworks/ngx-groundworks-auth';
import { ShellComponent } from './components/shell/shell';
import { ViewerComponent } from './components/viewer/viewer';
import { WeekViewCalendarComponent } from './components/week-view-calendar/week-view-calendar.component';
import { MonthlyCapacityComponent } from './components/monthly-capacity/monthly-capacity.component';
import { authorizationGuard } from './guards/authorization.guard';
import { permittingGuard } from './guards/permitting.guard';
import { commissionsGuard } from './guards/commissions.guard';
import { ppjGuard } from './guards/ppj.guard';
import { accountsReceivableGuard } from './guards/accounts-receivable.guard';
import { ProjectsListboxComponent } from './components/projects-listbox/projects-listbox.component';

export const routes: Routes = [
  {
    path: '',
    canActivate: [MsalGuard, authorizationGuard],
    component: ShellComponent,
    children: [
      {
        path: '',
        component: ProjectsListboxComponent,
      },
      {
        path: 'viewer',
        component: ViewerComponent
      },
      {
        path: 'calendar',
        component: WeekViewCalendarComponent
      },
      {
        path: 'monthly-capacity',
        component: MonthlyCapacityComponent
      },
      {
        path: 'projects-to-be-completed',
        loadComponent: () =>
          import('./components/projects-to-be-completed-listbox/projects-to-be-completed-listbox.component')
            .then(m => m.ProjectsToBeCompletedListboxComponent)
      },
      {
        path: 'account-credit-requests',
        loadComponent: () =>
          import('./components/account-credit-requests-listbox/account-credit-requests-listbox.component')
            .then(m => m.AccountCreditRequestsListboxComponent)
      },
      {
        path: 'permitting-task-lists',
        canActivate: [permittingGuard],
        loadComponent: () =>
          import('./components/permits-listbox/permits-listbox.component')
            .then(m => m.PermitsListboxComponent)
      },
      {
        path: 'commissions',
        canActivate: [commissionsGuard],
        loadComponent: () =>
          import('./components/commissions-listbox/commissions-listbox.component')
            .then(m => m.CommissionsListboxComponent)
      },
      {
        path: 'ppj-projects',
        canActivate: [ppjGuard],
        loadComponent: () =>
          import('./components/ppj-projects-listbox/ppj-projects-listbox.component')
            .then(m => m.PpjProjectsListboxComponent)
      },
      {
        path: 'accounts-receivable',
        canActivate: [accountsReceivableGuard],
        loadComponent: () =>
          import('./components/accounts-receivable-listbox/accounts-receivable-listbox.component')
            .then(m => m.AccountsReceivableListboxComponent)
      }
    ]
  },
];
